// removed by extract-text-webpack-plugin
module.exports = {"ButtonContainer":"ButtonContainer__hRTa3","Text":"Text__1YX6g","Image":"Image__TEJD4"};


//////////////////
// WEBPACK FOOTER
// ./components/Buttons/Button/style.scss
// module id = RIoB
// module chunks = 0